import React from 'react'
import Businesses from 'containers/Businesses'

export default function BusinessesPage() {
  return <Businesses />
}
